import { FC } from 'react';

import { PageTitleProps } from './types';

import styles from './styles.module.scss';

export const PageTitle: FC<PageTitleProps> = ({ title }) => {
  return <h1 className={styles.pageTitle}>{title}</h1>;
};
